import { Logtail } from "@logtail/edge";
/**
 * BetterStack logging backend using official Logtail Edge SDK
 * Ships logs to BetterStack Logs API with proper ExecutionContext handling
 *
 * @see https://betterstack.com/docs/logs/cloudflare-worker/
 */
export class BetterStackBackend {
    baseLogger;
    ctx = null;
    constructor(token, endpoint) {
        const options = {
            warnAboutMissingExecutionContext: false,
        };
        if (endpoint) {
            options.endpoint = endpoint;
        }
        this.baseLogger = new Logtail(token, options);
    }
    /**
     * Set ExecutionContext for proper log flushing in Cloudflare Workers
     * Call this at the beginning of each request handler
     */
    setContext(ctx) {
        this.ctx = ctx;
    }
    /**
     * Send log entry to BetterStack
     * Uses ExecutionContext when available for proper log flushing
     */
    send(entry) {
        // Get logger with ExecutionContext if available.
        // The local ExecutionContext stub is an intentional structural subset of the
        // @cloudflare/workers-types type; cast at this boundary so future additions of
        // required fields (e.g. `tracing`) to the upstream type don't break the build.
        const logger = this.ctx
            ? this.baseLogger.withExecutionContext(this.ctx)
            : this.baseLogger;
        // Map log level to Logtail method
        const level = entry.level.toLowerCase();
        const { message, level: _level, ...context } = entry;
        // Use appropriate log level. Fire-and-forget on purpose — send() is sync;
        // ExecutionContext.waitUntil (attached via ctx above) handles pending
        // promises across the worker lifetime.
        switch (level) {
            case "debug":
                void logger.debug(message, context);
                break;
            case "info":
                void logger.info(message, context);
                break;
            case "warn":
                void logger.warn(message, context);
                break;
            case "error":
                void logger.error(message, context);
                break;
            default:
                void logger.info(message, context);
        }
    }
    /**
     * Flush pending logs
     * Important for serverless environments to ensure logs are sent before shutdown
     */
    async flush() {
        await this.baseLogger.flush();
    }
}
//# sourceMappingURL=betterstack.js.map